import React from "react";
import { DialogWrapper } from "../common/Dialog";
import { DialogProps } from "../../types/dialog-types";
import { getTigerResource } from "../../utils/tigerResource";

export interface RestartUIDialogProps extends DialogProps {
  onOk?: () => void;
  onCancel?: () => void;
}

export function RestartUIDialog({
  open,
  onClose,
  onOk,
  onCancel,
}: RestartUIDialogProps) {
  const handleOk = () => {
    onOk?.();
    onClose();
  };

  const handleCancel = () => {
    onCancel?.();
    onClose();
  };

  return (
    <DialogWrapper open={open} onClose={onClose} title={getTigerResource("TIGER_RESTART_TITLE")} width={420}>
      <div className="dialog-body">
        <div className="dialog-icon-row">
          <span className="dialog-icon dialog-icon-warning" aria-label={getTigerResource("TIGER_QUERY_SEV_WARN")}>&#9888;</span>
          <span className="dialog-icon-text">
            {getTigerResource("TIGER_RESTART_MSG")}
          </span>
        </div>
      </div>
      <div className="dialog-buttons">
        <button className="dialog-btn" onClick={handleOk}>{getTigerResource("TIGER_RES_OK")}</button>
        <button className="dialog-btn" onClick={handleCancel}>{getTigerResource("TIGER_RES_CANCEL")}</button>
      </div>
    </DialogWrapper>
  );
}
